import { render } from "./SignPending.vue?vue&type=template&id=7d9ada86"
import script from "./SignPending.vue?vue&type=script&lang=js"
export * from "./SignPending.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__